<template>
	<AppInput
		ref="appInput"
		:id="id"
		:modelValue="modelValue"
		:placeholder="placeholder"
		type="text"
		:isDisabled="isDisabled"
		:hasError="hasError"
		:hasIcon="true"
		iconPosition="left"
		:size="size"
		:border="computedBorder"
		:autocomplete="remember ? 'on' : 'off'"
		@update:modelValue="$emit('update:modelValue', $event)"
		@focus="$emit('focus', $event)"
		v-bind="$attrs"
	>
		<template #label v-if="$slots.label">
			<slot name="label"/>
		</template>
		<template #icon-left v-if="$slots['icon-left']">
			<div class="p-2">
				<slot name="icon-left" />
			</div>
		</template>

		<template #icon-right v-if="$slots['icon-right']">
			<div class="p-2">
				<slot name="icon-right" />
			</div>
		</template>
	</AppInput>
</template>

<script>
import { defineComponent } from 'vue'
import AppInput from '@/components/ui/inputs/AppInput.vue'
import { mapGetters } from 'vuex'

export default defineComponent({
	name: 'InputText',
	components: { AppInput },
	inheritAttrs: false,
	props: {
		id: String,
		modelValue: String,
		placeholder: String,
		isDisabled: Boolean,
		hasError: Boolean,
		size: String,
		border: String,
		remember: {
			type: Boolean,
			default: false
		}
	},
	emits: ['update:modelValue', 'focus'],
	computed: {
		...mapGetters('ui', ['buttonBorder']),
		computedBorder() {
			return this.border || this.buttonBorder || 'rounded'
		}
	},
	methods: {
		focus() {
			this.$refs.appInput?.focus()
		}
	}
})
</script>
